import React from 'react';

import Template from './Template';

const Route: React.FunctionComponent = () => {
  return <Template />;
};

export default Route;
